/* tslint:disable:max-line-length */
import {ViewFault} from '@docma-mm-core/fault/fault';
import {Injectable} from '@angular/core';
import {StructureService} from '@docma-mm-core/structure/structure.service';
import {firstValueFrom} from 'rxjs';
import {SortCriterionEnum, SortDirectionEnum, SortSourceEnum, TileSortState} from './mm-faults-view/services/mm-faults-sorting.service';

@Injectable()
export class MmLoadedFaultsSortingService {

  constructor(private readonly structureService: StructureService) {
  }

  async sortFaults(faults: ViewFault[], sortState: TileSortState) {
    const structures = await firstValueFrom(this.structureService.structuresDict$);

    if (sortState.criterion === SortCriterionEnum.Number) {
      return faults.sort((a, b) => {
        return (sortState.direction === SortDirectionEnum.Ascending ? a.data.Number1 - b.data.Number1 : b.data.Number1 - a.data.Number1);
      });
    } else if (sortState.criterion === SortCriterionEnum.Number2) {
      return faults.sort((a, b) => {

        let number2ldfA = 0;
        let number2ldfB = 0;

        if (a.data.Number2 && a.data.Number2 !== '') {
          const escapedSuffixA = escapeString((a.data.Number2Suffix ?? ''));
          const escapedPrefixA = escapeString((a.data.Number2Prefix ?? ''));
          const suffixPatternA = new RegExp(`${escapedSuffixA}$`);
          // const suffixPatternA = new RegExp(`(${escapeString(a.data.Number2)}${(escapedSuffixA !== '' ? `|${escapedSuffixA}` : '')})$`);
          const prefixPatternA = new RegExp(`^${escapedPrefixA}`);
          let lfdA = (escapedSuffixA !== '' ? a.data.Number2.replace(suffixPatternA, '') : a.data.Number2);
          lfdA = (escapedPrefixA !== '' ?  lfdA.replace(prefixPatternA, '') : lfdA);
          number2ldfA = (isNaN(+lfdA) ? 0 : +lfdA);
        }

        if (b.data.Number2 && b.data.Number2 !== '') {
          const escapedSuffixB = escapeString((b.data.Number2Suffix ?? ''));
          const escapedPrefixB = escapeString((b.data.Number2Prefix ?? ''));
          const suffixPatternB = new RegExp(`${escapedSuffixB}$`);
          // const suffixPatternB = new RegExp(`(${escapeString(b.data.Number2)}${(escapedSuffixB !== '' ? `|${escapedSuffixB}` : '')})$`);
          const prefixPatternB = new RegExp(`^${escapedPrefixB}`);
          let lfdB = (escapedSuffixB !== '' ? b.data.Number2.replace(suffixPatternB, '') : b.data.Number2);
          lfdB = (escapedPrefixB !== '' ?  lfdB.replace(prefixPatternB, '') : lfdB);
          number2ldfB = (isNaN(+lfdB) ? 0 : +lfdB);
        }

        return (sortState.direction === SortDirectionEnum.Ascending ?
          (a.data.Number2Prefix ?? '').localeCompare((b.data.Number2Prefix ?? '')) || (number2ldfA - number2ldfB) || (a.data.Number2Suffix ?? '').localeCompare((b.data.Number2Suffix ?? '')) :
          (b.data.Number2Prefix ?? '').localeCompare((a.data.Number2Prefix ?? '')) || (number2ldfB - number2ldfA) || (b.data.Number2Suffix ?? '').localeCompare((a.data.Number2Suffix ?? '')));
      });
    } else if (sortState.criterion === SortCriterionEnum.Description1) {
      return faults.sort((a, b) => {
        return (sortState.direction === SortDirectionEnum.Ascending ?
          (a.data.Desc1_1 ?? '').localeCompare((b.data.Desc1_1 ?? '')) :
          (b.data.Desc1_1 ?? '').localeCompare((a.data.Desc1_1 ?? '')));
      });
    } else if (sortState.criterion === SortCriterionEnum.Structure) {
      return faults.sort((a, b) => {
        // const dateA = new Date(a.creationDate).getTime();
        // const dateB = new Date(b.creationDate).getTime();
        const stA = (structures.hasOwnProperty(a.data.Structure.Id) ? structures[a.data.Structure.Id].StructureSortId : 0);
        const stB = (structures.hasOwnProperty(b.data.Structure.Id) ? structures[b.data.Structure.Id].StructureSortId : 0);
        return (sortState.direction === SortDirectionEnum.Ascending ? stA - stB : stB - stA);
      });
    } else if (sortState.criterion === SortCriterionEnum.CreatedOn) {
      return faults.sort((a, b) => {
        const createdOnA = new Date(a.data.CreatedOn).getTime();
        const createdOnB = new Date(b.data.CreatedOn).getTime();
        return (sortState.direction === SortDirectionEnum.Ascending ? createdOnA - createdOnB : createdOnB - createdOnA);
      });
    }

    return faults;
  }
}

function escapeString(str: string) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


